import React from 'react';

export default React.createContext({
  clientID: null,
  token: null,
  login: (username,password) => {},
  logout: ()=>{}
})